import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface MessageEmitData {
  channel: string;
  data: MessageServiceData;
}
export interface MessageServiceData {
  navigatingMicroApps: boolean
  functionName: string
  options?: any
}

@Injectable()
export class MessageService {
  private subject = new Subject<any>();

  public emit(channel: string, data: MessageServiceData) {
    return this.subject.next({
      channel,
      data
    });
  }

  public getChannelObservable(channel: string): Observable<MessageEmitData> {
    return this.subject.asObservable().pipe(filter((res: MessageEmitData) => (res.channel === channel)));
  }
}
